var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_4955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2959 29.0952C16.4721 27.5754 16.0361 25.8059 16.0404 23.9993C16.0396 23.4552 16.0778 22.912 16.1546 22.3756L16.1249 22.3377C15.3245 21.3914 14.2888 20.7752 13.1706 20.5798C12.0524 20.3843 10.9108 20.6201 9.91414 21.2523C8.9175 21.8844 8.11859 22.8796 7.63522 24.0909C7.15184 25.3023 7.00958 26.6657 7.22942 27.9802V27.9897C7.88631 31.8993 9.50736 35.4897 11.8872 38.3059L18.3596 30.6594C17.9598 30.1836 17.6033 29.6593 17.2959 29.0952Z",
    fill: "url(#paint0_linear_154_4955)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7041 18.9035C31.5279 20.4232 31.9639 22.1928 31.9596 23.9993C31.9604 24.5434 31.9222 25.0866 31.8454 25.6231L31.8751 25.661C32.6754 26.607 33.711 27.2231 34.829 27.4185C35.9471 27.614 37.0886 27.3783 38.0851 26.7463C39.0817 26.1144 39.8806 25.1195 40.3641 23.9084C40.8476 22.6974 40.9901 21.3341 40.7706 20.0198V20.0103C40.1159 16.0994 38.4964 12.507 36.1174 9.68869L29.6404 17.3325C30.0406 17.8103 30.3971 18.3369 30.7041 18.9035Z",
    fill: "url(#paint1_linear_154_4955)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7712 27.8314L29.7877 38.4872C30.1945 38.9679 30.6773 39.3489 31.2084 39.6085C31.7395 39.868 32.3086 40.0009 32.883 39.9996C33.4575 39.9984 34.0261 39.863 34.5564 39.6011C35.0866 39.3393 35.5682 38.9562 35.9736 38.4737C39.2321 34.597 41.1244 29.355 41.0982 23.8816C41.0922 22.584 40.9821 21.29 40.7695 20.0171C40.989 21.3314 40.8465 22.6946 40.363 23.9057C39.8795 25.1168 39.0805 26.1117 38.084 26.7436C37.0874 27.3756 35.946 27.6112 34.8279 27.4158C33.7099 27.2204 32.6743 26.6043 31.874 25.6582L31.8443 25.6204L27.2288 20.174L18.2124 9.51955C17.3906 8.54878 16.2773 8.00471 15.1173 8.007C13.9572 8.00928 12.8454 8.55772 12.0264 9.53172C8.76682 13.4084 6.87565 18.6504 6.90076 24.1238C6.90679 25.4219 7.01686 26.7163 7.22946 27.9897C7.00962 26.6752 7.15188 25.3117 7.63526 24.1004C8.11863 22.889 8.91754 21.8939 9.91418 21.2617C10.9108 20.6295 12.0524 20.3938 13.1706 20.5892C14.2889 20.7846 15.3245 21.4009 16.1249 22.3472L16.1546 22.385L20.7712 27.8314Z",
    fill: "#2563EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6756 18.8345C31.4994 20.3542 31.9353 22.1238 31.931 23.9303C31.9319 24.4744 31.8937 25.0176 31.8169 25.5541L31.8466 25.592C32.647 26.5382 33.6826 27.1545 34.8009 27.3499C35.9191 27.5453 37.0607 27.3096 38.0573 26.6774C39.054 26.0452 39.8529 25.0501 40.3363 23.8387C40.8196 22.6274 40.9619 21.2639 40.742 19.9494L40.742 19.94C40.0852 16.0304 38.4641 12.44 36.0843 9.62375L29.6119 17.2703C30.0117 17.7461 30.3682 18.2703 30.6756 18.8345Z",
    fill: "url(#paint2_linear_154_4955)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_4955",
    x1: 11.8335,
    y1: 20.8817,
    x2: 14.3852,
    y2: 36.9202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_4955",
    x1: -15714.4,
    y1: -17890.8,
    x2: -16154.6,
    y2: -19959.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_4955",
    x1: 36.138,
    y1: 27.0479,
    x2: 33.5863,
    y2: 11.0094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_4955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2008,
    height: 32,
    fill: "white",
    transform: "translate(6.8996 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logoMark.7a0fc8a50a7efd2f7ea129d327c4af15.svg";
export { ForwardRef as ReactComponent };